import {Injectable} from '@angular/core';
import {Constants} from '../../shared/constants';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { Browser } from '@capacitor/browser';
declare const window: any;

@Injectable()
export class CommonService extends Constants {
  constructor(private router: Router, private platform: Platform) {
    super();
  }

  carouselOptions: any ={
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  };

  queryStream = new Subject<any>();

  searchEventStream = new Subject<String>();

  tokenStream = new Subject<String>();

  pincodeChange = new Subject<any>();

  login = new Subject<any>();

  androidLogIn = new Subject<any>();


  stringParams(params: any): string {
    let x = [];
    for (let k in params)
      x.push(k + "=" + params[k])
    return x.join('&');

  }

  setStorage(key, value): any {
    if (typeof value == "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  };
  getStorage(key): any {
    var x = localStorage.getItem(key);
    try {
      var xx = JSON.parse(x)
      return xx;
    } catch (e) {
      return x;
    }
  };
  removeStorage(key): any {
    localStorage.removeItem(key);
  };
  removeAllStorage(): any {
    localStorage.clear();
  };

  setNavigateUrl(navigateUrl: string): any {
    localStorage.setItem(this.navigateUrl, navigateUrl);
  };
  getNavigteUrl(): any {
    let navigateUrl = localStorage.getItem(this.navigateUrl);
    return navigateUrl == null ? '/' : navigateUrl;
  };


  getPercentage(item) {
    item.mrp = item.mrp == 0 ? item.mop : item.mrp;
    return Math.round((100 * (item.mrp - item.mop + item.cashback)) / item.mrp) / 100;
  }

  isLoggedIn() {
    let loggedIn = this.getStorage(this.loggedIn);
    return loggedIn == null ? false : loggedIn;
  }

  setLoggedIn(loggedIn: boolean) {
    this.setStorage(this.loggedIn, loggedIn);
    this.login.next(loggedIn);
  }


  getData() {
    return this.getStorage(this.registered)
  };
  getToken() {
    return this.getStorage(this.newToken);
  };

  getPincode() {
    return this.getStorage(this.pincode);
  };

  //unused
  setPincode(pin) {
    this.setStorage(this.pincode, pin);
  };

  isRetailer() {
    if ('userStatus' in this.getData()) {
      return this.checkRetailer.indexOf(this.getData()['userStatus']) != -1
    }
    return false;
  }

  isFofo() {
    return true;
  }

  isFofoAssociate() {
    return false;
  }


  getAndroidId() {
    return this.getStorage(this.androidId) || '54e9d8231b74c46';
  }
  setAndroidId(id) {
    this.setStorage(this.androidId, id);
  }

  goToProductPage(catalogId:number) {
    this.router.navigate(["pages/home/itemDetail", catalogId])
  }

  sortByPrice(type, data) {
    return data.sort((a, b) => {
      const priceA = a.items?.[0]?.sellingPrice || 0;
      const priceB = b.items?.[0]?.sellingPrice || 0;
      return type === 'asc' ? priceA - priceB : priceB - priceA;
    });
  }

  async openInBrowser(url: string) {
    if (this.platform.ANDROID || this.platform.IOS) {
      await Browser.open({ url });
    } else {
      window.open(url, '_blank');
    }
  }

}


